import {Injectable} from "@angular/core";


@Injectable()
export class DialogWrapperService {
    private dialogIds: string[] = [];

    constructor() {
    }

    addDialogId(id: string) {
        this.dialogIds.push(id);
    }

    removeDialogId(id: string) {
        this.dialogIds.splice(this.dialogIds.indexOf(id), 1);
    }

    isTopDialog(id: string) {
        if (this.dialogIds.length === 0)
            return false;
        return this.dialogIds[this.dialogIds.length - 1] === id;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/dialog-wrapper/dialog-wrapper.service.ts